import gql from "graphql-tag";

export const tenantPrivateDetailsFragment = gql`
  fragment TenantPrivateDetailsFragment on TenantPrivate {
    id
    legalName
    unitNo
    code
    leaseNo
    contractId
    tenantType
    description
    status
    operationStatus
    operationStartTime
    operationEndTime
    storeName
  }
`;
